import React from 'react';

import { branchSettingsPropType, patientPropType } from 'Shared/types';
import PropTypes from 'prop-types';
import EhrEncounterReviewContent from 'App/components/EHR/EhrEncounterReviewContent';
import { financialAssistanceReferralDetailsPropType } from './types';
import ContentByStatus from './ContentByStatus';

const FinancialAssistanceEncounterReviewContent = ({
    patient,
    branchSettings,
    medicationList,
    financialAssistanceReferralDetails,
}) => {
    return (
        <div>
            <EhrEncounterReviewContent
                patient={patient}
                branchSettings={branchSettings}
                medicationList={medicationList}
            />

            <ContentByStatus details={financialAssistanceReferralDetails} />
        </div>
    );
};

FinancialAssistanceEncounterReviewContent.propTypes = {
    patient: patientPropType.isRequired,
    branchSettings: branchSettingsPropType.isRequired,
    medicationList: PropTypes.arrayOf(
        PropTypes.shape({
            medication: PropTypes.shape({
                id: PropTypes.string,
                displayName: PropTypes.string,
            }),
        })
    ).isRequired,
    financialAssistanceReferralDetails: financialAssistanceReferralDetailsPropType.isRequired,
};

export default FinancialAssistanceEncounterReviewContent;
